import { useTranslation } from 'next-i18next/pages';

import { Form } from 'antd';

import { TranslationNamespace } from '@/i18n';

import { CompactInputNumber } from '../CompactInputNumber';
import { StepActions } from '../StepActions';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface TimeRowProps {
	name: string;
	label: string;
	hint: string;
	suffix: string;
}

function TimeRow({ name, label, hint, suffix }: TimeRowProps) {
	return (
		<div className={styles.timeRow}>
			<label htmlFor={name}>
				{label} <span className={styles.hint}>{hint}</span>
			</label>
			<Form.Item name={name} noStyle>
				<CompactInputNumber id={name} min={0} step={1} addon={suffix} size="large" />
			</Form.Item>
		</div>
	);
}

interface StepTimeProps {
	onPrev: () => void;
	onNext: () => void;
}

export function StepTime({ onPrev, onNext }: StepTimeProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<div className={styles.stepPanel}>
			<h2 className={styles.stepTitle}>{t('time.title')}</h2>
			<p className={styles.stepLead}>{t('time.description')}</p>

			<div className={styles.timeTable}>
				<TimeRow
					name="orderMinutes"
					label={t('time.application')}
					hint={t('time.per-application')}
					suffix={t('units.minutes-application')}
				/>
				<TimeRow
					name="stockMinutes"
					label={t('time.retention')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="reportMinutes"
					label={t('time.reports')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="priceMinutes"
					label={t('time.prices')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="counterpartyMinutes"
					label={t('time.counterparties')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="communicationMinutes"
					label={t('time.buyers')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="documentMinutes"
					label={t('time.documents')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
				<TimeRow
					name="otcMinutes"
					label={t('time.off-exchange')}
					hint={t('time.workday')}
					suffix={t('units.minutes-day')}
				/>
			</div>

			<StepActions onPrev={onPrev} onNext={onNext} />
		</div>
	);
}
